'use client';

import { Breadcrumb, BreadcrumbItemProps } from '@commenda/kakashi';
import { useRouter } from 'next/navigation';

const SalesTaxNavBar = ({
  items,
  hidden = false,
}: {
  items: BreadcrumbItemProps[];
  hidden?: boolean;
}) => {
  const router = useRouter();

  if (hidden) return null;

  const getBackClickFn = (): string | undefined => {
    const activeIndex = items.reverse().findIndex((item) => !!item.href);

    if (activeIndex > 0) {
      return items[activeIndex - 1].href;
    }
    return undefined;
  };

  const onBackClickHref = getBackClickFn();

  return (
    <Breadcrumb
      items={items}
      onBack={
        onBackClickHref ? () => router.push(onBackClickHref) : router.back
      }
    />
  );
};

export default SalesTaxNavBar;
